import { Layout } from "antd";
import { CIndicator } from "components";
import React from "react";
import { Outlet } from "react-router-dom";

const Content = () => {
  return (
    <Layout.Content style={{ overflowY: "auto" }} className="bg-white">
      <React.Suspense fallback={<CIndicator />}>
        <Outlet />
      </React.Suspense>
    </Layout.Content>
  );
};

export default Content;
